import React, { useState, useEffect, forwardRef } from 'react'
import { Input, message } from 'antd'
import { MinusCircleOutlined,PlusCircleOutlined } from '@ant-design/icons'
import * as API from '../../../api'
import './index.less'
interface ValueProps {
	url: string;
	id?: string;
	name?: string;
	src_id?: string;
	image?: string;
	price?: number;
}
interface RelateGoodsProps {
	value: ValueProps[];
	onChange: (value: ValueProps[]) => void;
}

const RelateGoods: React.FC<RelateGoodsProps> = forwardRef(({
	value,
	onChange
}) => {
	const [saleList, setGoods] = useState([{url:''}])
	useEffect(() => {
		setGoods(value)
	}, [value])

	const changeValue = async (e, index) => {
		const value = e.target.value
		saleList[index].url = value
		const { code, data, msg } = await API.checkSaleUrl({ goods_url: value})
		if(code === 0) {
			if(data) {
				let isTrue = true
				const filterList = saleList.filter(item => saleList.indexOf(item) != index)
				filterList.map(item => {
					if(item.src_id == data.src_id){
						isTrue= false
					}
				})
				if(isTrue) {
					saleList[index] = {
						name: data.name,
						src_id: data.src_id,
						image: data.image,
						url: value,
						price: data.price
					}
					setGoods([...saleList])
					onChange && onChange([...saleList])
				}else{
					setGoods([...saleList])
					message.error('关联商品链接不能重复添加')
				}
			}
		}else{
			message.error(msg)
		}
	}
	const addSale=() => {
		const len = saleList.length
		if(len >= 5){
			message.error('关联商品最多可添加五条')
		} else if(saleList[len-1].url == '') {
			message.error('您有未输入关联商品链接')
		} else {
			saleList.push({url: ''})
			setGoods([...saleList])
		}
	}
	const delSale= (e) => {
		saleList.splice(e, 1)
		setGoods([...saleList])
		onChange && onChange([...saleList])
	}
	return (
		<div className="goods-list-wrap">
			{
				saleList.map((item,index) =>
					<div className="goods-item-wrap"  key={index} style={{ position: 'relative' }}>
						<Input
							value={item.url}
							onChange={(e) => changeValue(e, index)}
							placeholder="请输入商品链接"
						/>
						{	index === 0 ?
							<></>
							:
							<MinusCircleOutlined
								style={{ color: '#38B66A', position: 'absolute', top: '9px', right: '-20px' }}
								onClick={() => delSale(index)}
							/>
						}
					</div>
				)
			}
			<PlusCircleOutlined
				style={{ color: '#38B66A' ,right: '-20px', position: 'absolute', top: '9px' }}
				onClick={addSale}
			/>
		</div>
	)
})

export default RelateGoods
